
  import Vue from "vue";
  import {MODAL_IDS, MODALS_LOADED} from "@/utils/modal";

  export default Vue.extend({
    name: "pwa-add-game-modal",
    components: {PwaAddGame: () => import("@/components/PwaAddGame.vue")},
    data() {
      return {
        loadContent: false,
      }
    },
    mounted(): void {
      MODALS_LOADED[this.modalId] = true;
    },
    computed: {
      modalId(): string {
        return MODAL_IDS.ADD_GAME;
      },
      defaultGameAlias(): string {
        return this.$store.getters.modalProps.defaultGameAlias || null;
      },
      defaultRelatedGameId(): number {
        return this.$store.getters.modalProps.defaultRelatedGameId || 0;
      },
      nextModal(): string {
        return this.$store.getters.modalProps.nextModal || '';
      },
      currentPage(): boolean {
        return this.$store.getters.modalProps.currentPage || false;
      }
    },
    methods: {
      onShow() {
        if (!this.loadContent) {
          this.loadContent = true;
        }
      },
    }
  });
